module.exports = __webpack_public_path__ + "img/plan-2.ecd61d08.png";